import React, { FC } from 'react'
import { IconButton, IconButtonProps } from '@chakra-ui/react'
import { Chevron, Direction } from '../../icons'
import { useColor } from '../../theme'

export interface CarouselArrowProps extends Omit<IconButtonProps, '_hover' | 'aria-label' | 'icon' | 'onClick' | 'opacity'> {
    direction: 'left' | 'right'
    iconClassName?: string
    isDisabled?: boolean
    onClick?: () => void
}

export const CarouselArrow: FC<CarouselArrowProps> = ({
    direction,
    iconClassName,
    isDisabled = false,
    variant = 'tertiary',
    position = 'absolute',
    onClick,
    ...restProps
}) => {
    const isLeft = direction === 'left'
    const ariaLabel = isLeft ? 'Previous' : 'Next'
    const defaultIconClassName = isLeft ? 'prev-icon-button' : 'next-icon-button'
    const chevronDirection = isLeft ? Direction.Left : Direction.Right

    const enabledColor = useColor({ nuance: 5, palette: 'primary' })
    const hoveredColor = useColor({ nuance: 7, palette: 'primary' })
    const disabledOpacity = 0.4
    const enabledOpacity = 1

    return (
        <IconButton
            _hover={isDisabled ? {} : {
                color: hoveredColor,
                opacity: enabledOpacity
            }}
            aria-label={ariaLabel}
            color={enabledColor}
            disabled={isDisabled}
            height="44px"
            icon={
                <Chevron
                    className={iconClassName ?? defaultIconClassName}
                    direction={chevronDirection}
                    height={7}
                    transition="opacity 0.3s, color 0.3s"
                    width={5}
                />
            }
            onClick={isDisabled ? undefined : onClick}
            opacity={isDisabled ? disabledOpacity : enabledOpacity}
            position={position}
            variant={variant}
            width="44px"
            {...restProps}
        />
    )
}
